// extracted by mini-css-extract-plugin
export default {"label":"WJi0eUxr","mobile":"mobile","text":"jV17QQqg"};